import { Image, Typography } from 'antd'
import { ReactNode } from 'react'

interface IChildrenProps {
  children?: ReactNode
}

interface IAuthCardHeader {
  title: string
  subtitle: string
  image: string
}

const AuthCard = (props: IChildrenProps) => {
  return <div className="auth-card">{props.children}</div>
}

const Body = (props: IChildrenProps) => <div className="auth-card__body">{props.children}</div>

const Footer = (props: IChildrenProps) => <div className="auth-card__footer">{props.children}</div>

const Header = (props: IAuthCardHeader) => (
  <div className="auth-card__header">
    <Image preview={false} src={props.image} className="auth-card__logo" />
    <Typography.Title className="auth-card__title">{props.title}</Typography.Title>
    <Typography.Text className="auth-card__subtitle">{props.subtitle}</Typography.Text>
  </div>
)

AuthCard.Body = Body
AuthCard.Footer = Footer
AuthCard.Header = Header

export default AuthCard
